import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/hplc-method-transfer/pages/CalculatorPage";

export const Route = createFileRoute("/hplc-method-transfer")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/hplc-method-transfer",
      title: m.hplc_meta_title(),
      description: m.hplc_meta_description(),
      toolName: m.hplc_tool_name(),
      faqs: [
        { q: m.hplc_faq_q1(), a: m.hplc_faq_a1() },
        { q: m.hplc_faq_q2(), a: m.hplc_faq_a2() },
        { q: m.hplc_faq_q3(), a: m.hplc_faq_a3() },
        { q: m.hplc_faq_q4(), a: m.hplc_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
